import { sequenceSingleModal } from './sequenceSingleModal'
import { updateNodeConnections } from '../../utils/functions'
import { nanoid } from 'nanoid/async'

// eslint-disable-next-line
export default async (node, editor) => {
  const oldData = node.data
  const { value: sequenceSingleData } = await sequenceSingleModal(oldData, node)

  if (sequenceSingleData && Object.values(sequenceSingleData).length >= 0) {

    if (! ('newPostbackId' in node.data)) {
      node.data.newPostbackId = await nanoid(15)
    }

    Object.assign(node.data, sequenceSingleData)
    node.update()
    updateNodeConnections(node)
  }

  return false
}